import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import cacheFrom from '@/utils/cache';
import { deepCopy } from '@/utils/utils';
import Vue from 'vue';
var deepGet = function deepGet(str, obj) {
  var arr = str.split('.');
  var res = arr.reduce(function (p, c) {
    return p[c];
  }, obj);
  return res;
};
export function getCache(cacheKey) {
  var fieldList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var callback = arguments.length > 2 ? arguments[2] : undefined;
  var fieldListFnCallback = arguments.length > 3 ? arguments[3] : undefined;
  var cacheData = cacheFrom.getCache(cacheKey);
  console.log('AutoConsole: 获取缓存 -> cacheKey', cacheKey, cacheData);
  if (cacheData) {
    var data = deepCopy(cacheData);
    callback && callback(data);
    if (fieldList.length) {
      fieldListFn(fieldList, data, fieldListFnCallback);
    }
  }
  return cacheData;
}
export function setCache(cacheKey, setCacheData) {
  console.log('设置缓存', cacheKey, deepCopy(setCacheData));
  cacheFrom.setCache(cacheKey, setCacheData);
}
export function removeCache(cacheKey) {
  var cache = cacheFrom.getCache(cacheKey);
  if (cache) {
    console.log('清除缓存');
    cache && cacheFrom.removeCache(cacheKey);
  }
}
export function fieldListFn() {
  var fieldList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cacheData = arguments.length > 1 ? arguments[1] : undefined;
  var fieldListFnCallback = arguments.length > 2 ? arguments[2] : undefined;
  try {
    var arr = fieldList.map(function (val) {
      var list = deepGet('customField', cacheData) || [];
      list.forEach(function (item) {
        if (item && val.id === item.id) {
          Vue.set(val.fieldMap, 'ovalue', item.value);
          Vue.set(val.fieldMap, 'tfvvalue', item.name);
          val.type === 9 && (val.addrList = item.value);
          if (val.type === 10 || val.type === 15 || val.type === 26) {
            Vue.set(val.fieldMap, 'defaultValue', item.value);
          }
        }
      });
      return val;
    });
    fieldListFnCallback && fieldListFnCallback(arr);
  } catch (error) {
    console.log('自定义字段', error);
  }
}